import CryptoJS from "crypto-js";

// Static secret key for consistent encoding/decoding - you may want to move this to config
const SECRET_KEY = import.meta.env.VITE_MEM_EXTENSION_AUTH_SECRET_KEY;

/**
 * Encrypts a string using AES encryption with CryptoJS
 * Returns an encrypted string that can be decrypted later
 */
export const encodeWithSalt = (data: string): string => {
  try {
    const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
    return encrypted;
  } catch (error) {
    throw new Error(`Failed to encode data: ${error}`);
  }
};

/**
 * Decrypts a string that was encrypted with encodeWithSalt
 */
export const decodeWithSalt = (encryptedData: string): string => {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const originalData = decrypted.toString(CryptoJS.enc.Utf8);

    if (!originalData) {
      throw new Error("Failed to decrypt data - invalid encrypted string or wrong key");
    }

    return originalData;
  } catch (error) {
    throw new Error(`Failed to decode data: ${error}`);
  }
};
